export type PathwayAddModalItem = {
  id: number
  name: string
  portal?: string
}

export const OLD_PATHWAYS_COUNT = 5
